import { render, staticRenderFns } from "./DialogFreigabeStellvertreter.vue?vue&type=template&id=afa910f4&scoped=true"
import script from "./DialogFreigabeStellvertreter.vue?vue&type=script&lang=ts"
export * from "./DialogFreigabeStellvertreter.vue?vue&type=script&lang=ts"
import style0 from "./DialogFreigabeStellvertreter.vue?vue&type=style&index=0&id=afa910f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa910f4",
  null
  
)

export default component.exports